<template>
  <div
    class="banner-page inner-page contact-page"
    v-if="franchise.banner_image"
    :style="`background-image: url('${getImageUrl(
      franchise.banner_image
    )}'); background-size: cover; background-repeat: no-repeat; background-position: center center;`"
  >
    <div class="content">
      <div class="banner-text" :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ franchise.banner_title }}</div>
      <p>
        {{ franchise.banner_description }}
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "FranchiseBannerPageComponent",

  data() {
    return {
      langStore,
      franchise: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchFranchise();
    },
  },

  mounted() {
    this.fetchFranchise();
  },

  methods: {
    async fetchFranchise() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/franchise`,
          { params: { lang: this.langStore.lang } }
        );

        this.franchise = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },

    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
  },
};
</script>

<style scoped>
.content p {
  padding-left: 15%;
  padding-right: 15%;
}
</style>
